import React from "react";
import { styled } from "@material-ui/styles";
import { IStyledArguments } from "../../types/styled-arguments";
import { gql, useQuery } from "@apollo/client";
import Link from "../link";
import messages from "./ScoutCard.intl";
import { injectIntl } from "react-intl";

const SCOUTING_PLAYERS = gql`
  query ScoutingPlayers {
    allPlayers(team: "scouting") {
      id
    }
  }
`;

const CardWrapper = styled(Link)(({ theme }: IStyledArguments) => ({
  display: "block",
  textDecoration: "none",
  background: theme.palette.primary.main,
  borderRadius: 18,
  padding: theme.spacing(2.5, 2.75),
  boxSizing: "border-box",
  height: "100%",
  transition: "background 0.2s ease",
  "&:hover": {
    background: theme.palette.primary.dark,
  },
}));

const Row = styled("div")({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
});

const Eyebrow = styled("div")(({ theme }: IStyledArguments) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(0.75),
  fontFamily: theme.typography.alternateFontFamily,
  fontSize: "0.65rem",
  fontWeight: 700,
  letterSpacing: 0.8,
  textTransform: "uppercase",
  color: "rgba(255, 255, 255, 0.85)",
  "& svg": {
    color: "rgba(255, 255, 255, 0.85)",
  },
}));

const CountValue = styled("div")(({ theme }: IStyledArguments) => ({
  fontFamily: theme.typography.alternateFontFamily,
  fontWeight: 800,
  fontSize: "2.4rem",
  lineHeight: 1.1,
  color: "#ffffff",
  marginTop: theme.spacing(0.5),
  fontVariantNumeric: "tabular-nums",
}));

const Caption = styled("div")({
  fontSize: "0.75rem",
  color: "rgba(255, 255, 255, 0.85)",
  marginTop: 2,
});

const ChevronCircle = styled("div")({
  width: 38,
  height: 38,
  borderRadius: "50%",
  background: "rgba(255, 255, 255, 0.15)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
});

const ScoutCard = injectIntl<any>(({ intl }) => {
  const { data } = useQuery(SCOUTING_PLAYERS);
  const count = data && data.allPlayers ? data.allPlayers.length : 0;

  return (
    <CardWrapper to={`/scouting`}>
      <Row>
        <div>
          <Eyebrow>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2}>
              <circle cx="11" cy="11" r="7" />
              <path d="M21 21l-4.3-4.3" />
            </svg>
            {intl.formatMessage(messages.scoutTitle)}
          </Eyebrow>
          <CountValue>{count}</CountValue>
          <Caption>{intl.formatMessage(messages.scoutCaption, { n: count })}</Caption>
        </div>
        <ChevronCircle>
          <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="#ffffff" strokeWidth={2.4} strokeLinecap="round" strokeLinejoin="round">
            <polyline points="9 6 15 12 9 18" />
          </svg>
        </ChevronCircle>
      </Row>
    </CardWrapper>
  );
});

export default ScoutCard;
